import React, { memo, useContext, useEffect, useState } from 'react';
import { t } from 'ttag';

// eslint-disable-next-line import/no-cycle
import { HeaderContext } from '../Header';

function Account({ isVisible = true }) {
  const { isLoggedIn, firstName } = useContext(HeaderContext);
  const [showProfileNotifcation, toggleProfileNotification] = useState(false);

  useEffect(() => {
    if (!window?.localStorage?.getItem('showProfileNotification')) {
      window?.localStorage?.setItem('showProfileNotification', 'True');
      toggleProfileNotification(true);
    } else {
      toggleProfileNotification(
        window?.localStorage?.getItem('showProfileNotification') === 'True'
      );
    }
  }, []);

  if (!isVisible) return null;

  return (
    <a
      href={isLoggedIn ? '/account/home/' : '/account/login/'}
      className="relative flex items-center gap-x-2 p-3 text-black outline-none focus:outline-none"
      aria-label={isLoggedIn ? t`Go to Unisport FC` : t`Login to Unisport FC`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
      >
        <circle cx="12" cy="8" r="5" />
        <path d="M20 21a8 8 0 1 0-16 0" />
      </svg>
      {showProfileNotifcation && (
        <div className="absolute bottom-3 left-3 h-2 w-2 rounded-full bg-[#640CD4]" />
      )}
      {firstName && (
        <span className="hidden items-center gap-x-1 font-semibold text-black lg:flex">
          {t`Hi`} {firstName}
        </span>
      )}
    </a>
  );
}

export default memo(Account);
